export default function CtaSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="relative rounded-2xl overflow-hidden">
          <div className="h-[320px] md:h-[400px]">
            <img
              src="https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20of%20trendy%20fashion%20items%20including%20sneakers%20hoodies%20and%20accessories%20arranged%20elegantly%20on%20a%20warm%20beige%20surface%2C%20soft%20film%20grain%20texture%2C%20editorial%20photography%20style%2C%20warm%20neutral%20tones%2C%20no%20text%2C%20artistic%20minimalist%20composition%20with%20gentle%20shadows&width=1400&height=600&seq=cta-final-bg-01&orientation=landscape"
              alt="CSSBuy Spreadsheet curated fashion collection"
              title="CSSBuy Spreadsheet CSSBuy Finds Collection"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/20 to-transparent"></div>
          </div>

          <div className="absolute inset-0 flex flex-col items-center justify-end pb-12 md:pb-16 px-4 text-center">
            <p className="text-xl md:text-3xl text-background-50 font-heading font-light italic mb-2">
              Ready to discover your next<br />
              <strong className="font-bold not-italic">CSSBuy Spreadsheet</strong> gem?
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="mt-6 px-8 py-3.5 bg-foreground-950 text-background-50 rounded-full text-sm md:text-base font-semibold hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer inline-block"
            >
              Buy It Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}